import { applyMiddleware } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer
} from './reducers/userReducers.js'

import {
  ownerRegisterReducer,
  ownerLoginReducer,
  ownerDetailsReducer,
  ownerUpdateProfileReducer,
  ownerDisableReducer,
  ownerDeleteReducer
} from './reducers/ownerReducers.js'

import {
  myReceiptsReducer,
  deleteReceiptsReducer,
  updateReceiptReducer,
  detailReceiptReducer,
  categoryReceiptsReducer
} from './reducers/receiptReducers.js'

import {
  countRcptReducer,
  getRcptMetaReducer,
  getRcptCategoryReducer,
  ownerUniqueCustomersReducer,
  ownerDashboardStatsReducer
} from './reducers/dashboardReducers.js'

import { userContactReducer } from './reducers/contactReducers.js'

import {
  getReceiptSpendReducer,
  metaDailyTotalReducer,
  metaDailyTotalByOwnerReducer,
  ownerAverageTicketReducer
  // aiDailyTotalReducer
} from './reducers/metaReducers.js'

import {
  userListReducer,
  adminGetUserReducer,
  adminUpdateUserReducer,
  adminDeleteUserReducer
} from './reducers/adminReducers.js'

const ownerInfoFromStorage = localStorage.getItem('ownerInfo')
  ? JSON.parse(localStorage.getItem('ownerInfo'))
  : null

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
  ownerLogin: { ownerInfo: ownerInfoFromStorage }
}

const middleware = [thunk]

const store = configureStore(
  {
    reducer: {
      userLogin: userLoginReducer,
      countRcpt: countRcptReducer,
      getRcptMeta: getRcptMetaReducer,
      getRcptCategory: getRcptCategoryReducer,
      ownerUniqueCustomers: ownerUniqueCustomersReducer,
      ownerDashboardStats: ownerDashboardStatsReducer,
      userContact: userContactReducer,
      userRegister: userRegisterReducer,
      userList: userListReducer,
      userDetails: userDetailsReducer,
      userUpdateProfile: userUpdateProfileReducer,
      adminUpdateUser: adminUpdateUserReducer,
      adminGetUser: adminGetUserReducer,
      adminDeleteUser: adminDeleteUserReducer,
      myReceipts: myReceiptsReducer,
      deleteReceipts: deleteReceiptsReducer,
      updateReceipt: updateReceiptReducer,
      detailReceipt: detailReceiptReducer,
      categoryReceipts: categoryReceiptsReducer,
      getReceiptSpend: getReceiptSpendReducer,
      metaDailyTotal: metaDailyTotalReducer,
      ownerAverageTicket: ownerAverageTicketReducer,
      ownerRegister: ownerRegisterReducer,
      ownerLogin: ownerLoginReducer,
      ownerDetails: ownerDetailsReducer,
      ownerUpdateProfile: ownerUpdateProfileReducer,
      ownerDisable: ownerDisableReducer,
      ownerDelete: ownerDeleteReducer,
      metaDailyTotalByOwner: metaDailyTotalByOwnerReducer
    },
    devTools: process.env.NODE_ENV !== 'production'
  },
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
)

export default store
